export default {
  // Common
  'common.cancel': 'Cancel',
  'common.ok': 'OK',
  
  'menu.login': 'Login',
  'pages.layouts.userLayout.title': 'CRM Customer Relationship Management System',
  'pages.login.accountLogin.tab': 'Account Login',
  'pages.login.accountLogin.errorMessage': 'Incorrect email or password',
  'pages.login.failure': 'Login failed, please try again!',
  'pages.login.success': 'Login successful!',
  'pages.login.email.placeholder': 'Email',
  'pages.login.email.required': 'Please input your email!',
  'pages.login.email.invalid': 'Invalid email format!',
  'pages.login.password.placeholder': 'Password',
  'pages.login.password.required': 'Please input your password!',
  'pages.login.rememberMe': 'Remember me',
  'pages.login.forgotPassword': 'Forgot Password ?',
  'pages.login.submit': 'Login',
  'pages.login.loginWith': 'Login with :',
  'pages.login.registerAccount': 'Register Account',
  'pages.404.subTitle': 'Sorry, the page you visited does not exist.',
  'pages.404.buttonText': 'Back Home',
  // Dashboard translations
  'pages.dashboard.text': 'Seamlessly integrate store management ecosystem, providing remote points management solutions.',
  'pages.dashboard.headquartersManagement': 'Head Office Management',
  'pages.dashboard.storeTitle': 'This is a title',
  'pages.dashboard.management.title': 'Head Office Management',
  'pages.dashboard.orders': 'Invoices',
  'pages.dashboard.members': 'Members',
  'pages.dashboard.cards': 'Store Cards',
  'pages.dashboard.coupons': 'Discount Coupons',
  'pages.dashboard.store.online': 'Online',
  'pages.dashboard.store.offline': 'Offline',
  'pages.dashboard.store.points': 'Points',
  'pages.dashboard.store.cardValue': 'Card Value',
  // Card tooltips
  'pages.dashboard.tooltip.orders': 'Invoice List',
  'pages.dashboard.tooltip.members': 'Member List',
  'pages.dashboard.tooltip.cards': 'Gift Card List',
  'pages.dashboard.tooltip.coupons': 'Voucher List',
  'pages.dashboard.headquartersVoucher': 'Head Office Voucher',
  'pages.dashboard.headquartersVoucher.title': 'Create Head Office Voucher',
  'pages.dashboard.tooltip.qrcode': 'Show Member Registration QR Code',
  'pages.dashboard.qrcode.title': 'Member Registration QR Code',
  'pages.dashboard.qrcode.download': 'Download QR Code',
  'pages.dashboard.qrcode.close': 'Close',
  // Invoice List translations
  'pages.store.title': 'Dashboard',
  'pages.invoiceList.title': 'Invoice List',
  'pages.orderList.title': 'Invoice List',
  'pages.invoiceList.table.invoiceNumber': 'Invoice No',
  'pages.invoiceList.search.invoiceNumber.placeholder': 'Enter invoice no',
  'pages.invoiceList.search.invoiceNumber':'Invoice No',
  'pages.invoiceList.search.customerInfoType': 'Customer Info Type',
  'pages.invoiceList.search.customerInfo': 'Customer Info',
  'pages.invoiceList.search.reset': 'Reset',
  'pages.invoiceList.search.submit': 'Search',
  'pages.invoiceList.search.refresh': 'Refresh',
  'pages.invoiceList.customerInfo': 'Customer Info',
  'pages.invoiceList.search.customerInfoType.phone': 'Phone',
  'pages.invoiceList.search.customerInfoType.name': 'Name',
  'pages.invoiceList.search.customerInfoType.memberId': 'Member ID',
  'pages.orderList.invoiceTime': 'Invoice Time',
  'pages.invoiceList.search.customerInfo.placeholder': 'Please input',
  'pages.orderList.totalAmount': 'Total Amount',
  'pages.orderList.customerName': 'Customer Name',
  'pages.orderList.status': 'Status',
  'pages.orderList.status.pending': 'Pending',
  'pages.orderList.status.completed': 'Completed',
  'pages.orderList.status.cancelled': 'Cancelled',
  'pages.orderList.status.paid': 'Paid',
  'pages.orderList.status.refunded': 'Refunded',
  'pages.orderList.status.partiallyRefunded': 'Partially Refunded',
  'pages.orderList.actions': 'Actions',
  'pages.orderList.actions.details': 'Details',
  'pages.orderList.search.invoiceNo.placeholder': 'Enter invoice no',
  'pages.orderList.search.customerInfo.placeholder': 'Please input',
  'pages.orderList.search.reset': 'Reset',
  'pages.orderList.search.submit': 'Search',
  'pages.orderList.search.refresh': 'Refresh',
  'pages.orderList.customerInfo': 'Customer Info',
  'pages.orderList.customerInfo.phone': 'Phone',
  'pages.orderList.customerInfo.name': 'Name',
  'pages.orderList.customerInfo.memberId': 'Member ID',
  // Member List translations
  'pages.memberList.name': 'Name',
  'pages.memberList.search.info.placeholder': 'Please input',
  'pages.memberList.create': 'Create',
  'pages.memberList.title': 'Member List',
  'pages.memberList.memberId': 'Member ID',
  'pages.memberList.registerTime': 'Register Time',
  'pages.memberList.phone': 'Phone',
  'pages.memberList.email': 'Email',
  'pages.memberList.points': 'Points',
  'pages.memberList.actions': 'Actions',
  'pages.memberList.actions.details': 'Details',
  'pages.memberList.status': 'Status',
  'pages.memberList.status.active': 'Active',
  'pages.memberList.status.inactive': 'Inactive',
  'pages.memberList.search.memberId.placeholder': 'Enter member ID',
  'pages.memberList.search.info': 'Member Info',
  'pages.memberList.search.info.phone': 'Phone',
  'pages.memberList.search.info.name': 'Name',
  'pages.memberList.search.info.memberId': 'Member ID',
  'pages.memberList.search.info.email': 'Email',
  'pages.memberList.search.reset': 'Reset',
  'pages.memberList.search.submit': 'Search',
  'pages.memberList.search.refresh': 'Refresh',
  // Gift Card List translations
  'store.giftCard.list.title': 'Gift Card List',
  'store.giftCard.list.search.cardId': 'Card Number',
  'store.giftCard.list.search.phone': 'Phone',
  'store.giftCard.list.search.email': 'Email',
  'store.giftCard.list.search.status': 'Status',
  'store.giftCard.list.table.cardNumber': 'Card Number',
  'store.giftCard.list.table.balance': 'Balance',
  'store.giftCard.list.table.status': 'Status',
  'store.giftCard.list.table.createTime': 'Create Time',
  'store.giftCard.list.table.actions': 'Actions',
  'store.giftCard.list.table.view': 'View',
  'store.giftCard.list.create': 'Create',
  'store.giftCard.list.createTime': 'Create Time',
  'store.giftCard.list.phone': 'Phone',
  'store.giftCard.list.email': 'Email',
  'store.giftCard.list.balance': 'Current Balance',
  'store.giftCard.list.actions': 'Actions',
  'store.giftCard.list.status.inactive': 'Inactive',
  'store.giftCard.list.status.active': 'Active',
  'store.giftCard.list.actions.details': 'Details',
  'store.giftCard.list.status': 'Status',
  'store.giftCard.list.search.status.active': 'Active',
  'store.giftCard.list.search.status.inactive': 'Inactive',
  'store.giftCard.list.search.cardId.placeholder': 'Please enter card ID',
  'store.giftCard.list.search.info': 'Temporary User Information',
  'store.giftCard.list.search.info.phone': 'Phone',
  'store.giftCard.list.search.info.name': 'Name',
  'store.giftCard.list.search.info.email': 'Email',
  'store.giftCard.list.search.reset': 'Reset',
  'store.giftCard.list.search.submit': 'Search',
  'store.giftCard.list.search.refresh': 'Refresh',
  'store.giftCard.list.card.number': 'Gift Card Number',
  'store.giftCard.list.action': 'Action',
  'store.giftCard.list.detail': 'Details',
  // Voucher List translations
  'pages.voucherList.title': 'Voucher List',
  'pages.voucherList.voucherId': 'Voucher ID',
  'pages.voucherList.voucherName': 'Voucher Name',
  'pages.voucherList.startDate': 'Start Date',
  'pages.voucherList.createTime': 'Create Time',
  'pages.voucherList.phone': 'Phone',
  'pages.voucherList.email': 'Email',
  'pages.voucherList.amount': 'Amount',
  'pages.voucherList.minPurchase': 'Min Purchase',
  'pages.voucherList.expiryDate': 'Expiry Date',
  'pages.voucherList.action': 'Action',
  'pages.voucherList.actions': 'Actions',
  'pages.voucherList.detail': 'Details',
  'pages.voucherList.actions.details': 'Details',
  'pages.voucherList.status': 'Status',
  'pages.voucherList.status.active': 'Active',
  'pages.voucherList.status.inactive': 'Inactive',
  'pages.voucherList.status.expired': 'Expired',
  'pages.voucherList.status.used': 'Used',
  'pages.voucherList.create': 'Create Voucher',
  'pages.voucherList.createVirtual': 'Create Virtual Voucher',
  'pages.voucherList.createPhysical': 'Create Physical Voucher',
  'pages.voucherList.downloadPhysical': 'Download Physical Vouchers',
  'pages.voucherList.physicalVoucherNumber': 'Physical Voucher Number',
  'pages.voucherList.voucherNumber': 'Voucher Number',
  'pages.voucherList.distributionStore': 'Distribution Store',
  'pages.voucherList.contactValue': 'Contact Value',
  'pages.voucherList.all': 'All',
  'pages.voucherList.noStore': 'No accessible Store was found',
  'pages.voucherList.physical.quantity': 'Quantity',
  'pages.voucherList.physical.batch': 'Creation Batch',
  'pages.voucherList.physical.allBatches': 'All batches',
  'pages.voucherList.physical.loadError': 'Failed to load the Physical Voucher form',
  'pages.voucherList.physical.createSuccess': 'Successfully created {count} Physical Vouchers',
  'pages.voucherList.physical.createError': 'Failed to create Physical Vouchers',
  'pages.voucherList.physical.batchLoadError': 'Failed to load Physical Voucher batches',
  'pages.voucherList.physical.downloadError': 'Failed to download Physical Vouchers',
  'pages.voucherList.search.voucherId.placeholder': 'Please enter voucher ID',
  'pages.voucherList.search.info': 'Temporary User Information',
  'pages.voucherList.search.info.phone': 'Phone',
  'pages.voucherList.search.info.name': 'Name',
  'pages.voucherList.search.info.email': 'Email',
  'pages.voucherList.search.reset': 'Reset',
  'pages.voucherList.search.submit': 'Search',
  'pages.voucherList.search.refresh': 'Refresh',
  'pages.voucherList.modal.title': 'Create Voucher',
  'pages.voucherList.modal.bulkSend': 'Bulk Send',
  'pages.voucherList.modal.singleSend': 'Single Send',
  'pages.voucherList.modal.template': 'Voucher Template',
  'pages.voucherList.modal.templateName': 'Template Name',
  'pages.voucherList.modal.template.placeholder': 'Please select voucher template',
  'pages.voucherList.modal.selectTemplate': 'Select Voucher Template',
  'pages.voucherList.modal.selectMemberLevel': 'Select Member Level',
  'pages.voucherList.modal.memberList': 'Member List',
  'pages.voucherList.modal.memberLevelList': 'Member Level List',
  'pages.voucherList.modal.memberLevelName': 'Member Level Name',
  'pages.voucherList.modal.memberCount': 'User Count',
  'pages.voucherList.modal.memberCountText': '{count} users',
  'pages.voucherList.modal.selectMembers': 'Select Members',
  'pages.voucherList.modal.selectedCount': '{count} members selected',
  'pages.voucherList.modal.searchMember': 'Search Member',
  'pages.voucherList.modal.sendList': 'Send List',
  'pages.voucherList.modal.addToList': 'Add',
  'pages.voucherList.modal.removeFromList': 'Remove',
  'pages.voucherList.modal.submit': 'Submit',
  'pages.voucherList.modal.cancel': 'Cancel',
  'pages.voucherList.modal.noHeadOffice': 'Head office not found',
  'pages.voucherList.modal.fetchTemplatesFailed': 'Failed to fetch voucher templates',
  'pages.voucherList.modal.fetchMembersFailed': 'Failed to fetch members',
  'pages.voucherList.modal.searchFailed': 'Failed to search members',
  'pages.voucherList.modal.alreadyInList': 'Member already in send list',
  'pages.voucherList.modal.addSuccess': 'Added successfully',
  'pages.voucherList.modal.removeSuccess': 'Removed successfully',
  'pages.voucherList.modal.submitSuccess': 'Submitted successfully',
  'pages.voucherList.modal.template.required': 'Please select voucher template',
  'pages.voucherList.modal.memberLevel.required': 'Please select member level',
  'pages.voucherList.modal.members.required': 'Please add members to send',
  'pages.voucherList.modal.creating': 'Creating vouchers...',
  'pages.voucherList.modal.createSuccess': 'Successfully created {count} vouchers, CSV file downloaded',
  'pages.voucherList.modal.createFailed': 'Failed to create vouchers',
  'pages.voucherList.modal.emptyList': 'No data',
  // Invoice Details
  'pages.orderDetails.invoiceInfo': 'Invoice Information',
  'pages.orderDetails.invoiceNo': 'Invoice No.',
  'pages.orderDetails.invoiceNumber': 'Invoice Number',
  'pages.orderDetails.status': 'Status',
  'pages.orderDetails.status.paid': 'Paid',
  'pages.orderDetails.status.unpaid': 'Unpaid',
  'pages.orderDetails.status.refund': 'Refunded',
  'pages.orderDetails.status.partiallyRefunded': 'Partially Refunded',
  'pages.orderDetails.invoiceTime': 'Invoice Time',
  'pages.orderDetails.points': 'Points Earned',
  'pages.orderDetails.pointsEarned': 'Points Earned',
  'pages.orderDetails.notes': 'Notes',
  'pages.orderDetails.remarks': 'Remarks',
  'pages.orderDetails.noNotes': 'None',
  'pages.orderDetails.noRemarks': 'None',
  'pages.orderDetails.afterTransaction': 'After Transaction',
  'pages.orderDetails.items': 'Purchased Items',
  'pages.orderDetails.productAmount': 'Product Purchase Amount',
  'pages.orderDetails.consumption': 'Product Consumption',
  'pages.orderDetails.actualPayment': 'Actual Payment',
  'pages.orderDetails.serviceFee': 'Surcharge Fee',
  'pages.orderDetails.memberDiscount': 'Member Discount',
  'pages.orderDetails.memberPoints': 'Member Points Redeemed',
  'pages.orderDetails.giftCard': 'Gift Card Payment',
  'pages.orderDetails.voucherRedemption': 'Voucher Redemption',
  'pages.orderDetails.voucherNumber': 'Voucher Number',
  'pages.orderDetails.total': 'Total',
  'pages.orderDetails.customer': 'Customer Information',
  'pages.orderDetails.customerName': 'Name',
  'pages.orderDetails.customerBalance': 'Balance',
  'pages.orderDetails.balanceDescription': 'Current Balance',
  'pages.orderDetails.email': 'Email',
  'pages.orderDetails.phone': 'Phone',
  'pages.orderDetails.viewCustomerDetails': 'View Details',
  'pages.orderDetails.card': 'Card Information',
  'pages.orderDetails.cardNumber': 'Card Number',
  'pages.orderDetails.cardBalance': 'Balance',
  'pages.orderDetails.voucher': 'Voucher Information',
  'pages.orderDetails.voucherCode': 'Voucher Code',
  // Menu items
  'menu.home': 'Home',
  'menu.orders': 'Invoices',
  'menu.settings': 'Settings',
  'menu.memberList': 'Member List',
  'menu.giftCardList': 'Gift Card List',
  'menu.voucherList': 'Voucher List',
  'menu.invoiceList': 'Invoice List',
  'menu.invoiceDetails': 'Invoice Details',
  'pages.memberDetails.status.active': 'Active',
  'pages.memberDetails.status.inactive': 'Inactive',
  'pages.store.settings': {
    'title': 'Store Settings',
    'basicInfo': 'Basic Information',
    'storeName': 'Store Name',
    'storeName.required': 'Please enter store name',
    'action': 'Action',
    'edit': 'Edit Card',
    'delete': 'Delete',
    'giftCardLevel.add': 'Add Level',
    'voucherLevel.add': 'Add Level',
    'voucherLevelIndex': 'Level',
    'voucherLevelName': 'Level Name',
    'defaultBalance': 'Default Balance',
    'giftCardLevelDefaultBalance': 'Default Balance',
    'giftCardLevelDefaultBalance.required': 'Please enter default balance',
    'giftcardLevelIndex': 'Level',
    'giftcardLevelName': 'Level Name',
    'voucherLevelDefaultBalance': 'Default Balance',
    'voucherLevelDefaultBalance.required': 'Please enter default balance',
    'pointsPerDollar': 'Points per $1 spent',
    'pointsPerDollar.required': 'Please enter points per $1 spent',
    'dollarsPerPoint': 'Value per point',
    'dollarsPerPoint.required': 'Please enter value per point',
    'startDate': 'Start Date',
    'startDate.required': 'Please enter start date',
    'expiryDate': 'Expiry Date',
    'expiryDate.required': 'Please enter expiry date',
    'minPurchase': 'Minimum Purchase',
    'minPurchase.required': 'Please enter minimum purchase',
    'amount': 'Amount',
    'amount.required': 'Please enter amount',
    'memberLevels': 'Member Level Settings',
    'giftCardLevels': 'Gift Card Level Settings',
    'voucherLevels': 'Voucher Level Settings',
    'memberLevel.level': 'Level',
    'memberLevel.name': 'Level Name',
    'memberLevel.discountRate': 'Discount Rate',
    'memberLevel.add': 'Add Level',
    'memberLevelIndex': 'Level',
    'memberLevelName': 'Level Name',
    'memberLevelDiscountRate': 'Discount Rate',
    'save': 'Save Changes',
  },
  'pages.store.statistics': {
    'title': 'Communication Statistics',
    'headOffice': {
      'overview': 'Head Office Communication Overview',
      'emailQuota': 'Monthly Email Quota',
      'emailRemaining': 'Remaining Email Quota',
      'smsQuota': 'Monthly SMS Quota',
      'smsRemaining': 'Remaining SMS Quota',
      'emailTrend': 'Email Usage Trend',
      'smsTrend': 'SMS Usage Trend',
      'historyUsage': 'Historical Usage Statistics',
      'selectDateRange': 'Select Date Range:',
      'currentYearMonth': 'Current Year-Month',
      'last6Months': 'Last 6 Months Data',
      'emailUnit': 'emails',
      'smsUnit': 'messages',
      'noData': 'No Data',
      'loading': 'Loading...',
      'downloadExcel': 'Download Excel',
      'month': 'Month',
      'emailCount': 'Email Usage',
      'smsCount': 'SMS Usage',
      'emailResourcePackages': 'Email Resource Packages',
      'smsResourcePackages': 'SMS Resource Packages',
      'totalQuota': 'Total Quota',
      'used': 'Used',
      'remaining': 'Remaining',
      'expireDate': 'Expire Date',
      'status': 'Status',
      'active': 'Active',
      'expired': 'Expired',
      'total': 'Total',
      'emails': 'emails',
      'messages': 'messages',
    },
    'store': {
      'usage': 'Store Usage Statistics',
      'name': 'Store Name',
      'emailUsage': 'Monthly Email Usage',
      'smsUsage': 'Monthly SMS Usage',
      'action': 'Action (Last 6 Months)',
      'downloadSms': 'Download SMS Records',
      'downloadEmail': 'Download Email Records',
      
      'noData': 'No Data',
    },
    'smsCostCalculator': {
      'title': 'SMS Cost Calculator',
      'content': 'Message Content',
      'contentPlaceholder': 'Enter your SMS content, supports emojis and line breaks...',
      'recipients': 'Number of Recipients',
      'recipientsPlaceholder': 'Enter the number of recipients',
      'calculate': 'Calculate',
      'reset': 'Reset',
      'segmentCount': 'Segments',
      'segments': 'segments',
      'costPerMessage': 'Per Message',
      'totalCost': 'Total Cost',
      'priceDisclaimer': 'Prices are for reference only. Contact POS Supplier for accurate pricing',
      'tips': 'Tips',
      'tip1': '• Chinese characters or emojis increase segment count',
      'tip2': '• English only: 160 chars/message, then 153 chars per segment',
      'tip3': '• With Chinese/emoji: 70 chars/message, then 67 chars per segment',
      'tip4': '• Price per message: $0.18 AUD',
    },
  },
  'pages.store.memberDetails.record.date': 'Record Date',
  'pages.store.memberDetails': {
    'modify.points': 'Modify Points',
    'reset.points': 'Reset Points',
    'reason':'Reason',
    'edit.success': 'Edit Successful',
    'edit.fail': 'Edit Failed',
    'edit.submit': 'Submit',
    'edit.cancel': 'Cancel',
    'edit.title': 'Edit Information',
    'member': 'Member',
    'memberId': 'Member ID',
    'memberLevel': 'Member Level',
    'discount': 'Discount',
    'points.modify': 'Modify Points',
    'send.card': 'Send Member Card',
    'send.email': 'Send to Email',
    'send.phone': 'Send to Phone',
    'edit.info': 'Edit Information',
    'basic.info': 'Basic Information',
    'consumption.record': 'Consumption Record',
    'points.record': 'Points Record',
    'points.reward': 'Points Reward',
    'points.reward.modify': 'Modify Points Reward',
    'points.reward.points': 'Points',
    'points.reward.description': 'Description',
    'points.redeem': 'Points Redeem',
    'points.after': 'After',
    'points.time': 'Time',
    'points.change': 'Points Change',
    'points.change.before': 'Before',
    'points.change.after': 'After',
    'points.change.reason': 'Reason',
    'points.change.description': 'Description',
    'points.change.submit': 'Submit',
    'points.type': 'Type',
    'points.type.manual': 'Manual',
    'points.type.transaction': 'Transaction',
    'points.amount': 'Amount',
    'points.balance': 'Balance',
    'points.operation': 'Operation',
    'points.remark': 'Remark',
    
    'points.change.record': 'Points Change Record',
    'invoice.number': 'Invoice Number',
    'invoice.amount': 'Invoice Amount',
    'invoice.date': 'Invoice Date',
    'please.enter': 'Please Enter',
    'search': 'Search',
    'reset': 'Reset',
    'status': 'Status',
    'points': 'Points',
    'member.level': 'Member Level',
    'phone': 'Phone',
    'email': 'Email',
    'registration.time': 'Registration Time',
    'last.consumption': 'Last Consumption',
    'name': 'Name',
    'company': 'Company',
    'registration.store': 'Registration Store',
    'store.manager': 'Store Manager',
    'store': 'Store',
    'action': 'Action',
    'detail': 'Details',
    'status.active': 'Active',
    'status.inactive': 'Inactive',
    'status.pending_payment': 'Pending Payment',
    'status.paid': 'Paid',
    'status.refunded': 'Refunded',
    'status.partial_refund': 'Partial Refund',
    'total.points': 'Total Points',
    'rewardEnabled': 'Reward Points',
    'rewardEnabled.on': 'Enabled',
    'rewardEnabled.off': 'Disabled',
  },
  'pages.store.settings': {
    'title': 'Head Office Settings',
    'basicInfo': 'Basic Information',
    'storeName': 'Store Name',
    'storeName.required': 'Please input store name',
    'pointsPerDollar': 'Points earned per dollar spent',
    'dollarsPerPoint': 'Point redemptions per dollar',
    'dollarsPerPoint.required': 'Please input point redemptions per dollar',
    'memberLevels': 'Member Level Settings',
    'giftCardLevels': 'Gift Card Level Settings',
    'voucherLevels': 'Voucher Level Settings',
    'memberLevel.level': 'Level',
    'memberLevel.name': 'Level Name',
    'memberLevel.discountRate': 'Discount Rate',
    'memberLevel.add': 'Add Level',
    'memberLevel.maxLimit': 'You can only set up to 10 levels',

    'memberLevelIndex': 'Level',
    'memberLevelName': 'Level Name',
    'memberLevelDiscountRate': 'Discount Rate',
    'discountRate': 'Discount Rate',
    'memberPriceLevel': 'Member Price Level',
    'delete': 'Delete',
    'giftCardLevel.add': 'Add Level',
    'voucherLevel.add':'Add Level',
    'giftcardLevelIndex': 'Level',
    'giftcardLevelName': 'Level Name',
    'defaultBalance': 'Default Balance',
    'giftCardLevelDefaultBalance': 'Default Balance',
    'giftCardLevelDefaultBalance.required': 'Please input default balance',
    'voucherLevelIndex': 'Level',
    'voucherLevelName': 'Level Name',
    'edit': 'Edit',
    'expiryDate': 'Expiry Date',
    
    'voucherLevelExpiryDate': 'Expiry Date',
    'voucherLevelExpiryDate.required': 'Please input expiry date',
    'amount': 'Amount',
    'action': 'Action',
    'voucherLevelAmount': 'Amount',
    'voucherLevelAmount.required': 'Please input amount',
    'minPurchase': 'Minimum Purchase',
    'voucherLevelMinPurchase': 'Minimum Purchase',
    'voucherLevelMinPurchase.required': 'Please input minimum purchase',
    'startDate': 'Start Date',
    'voucherLevelStartDate': 'Start Date',
    'voucherLevelStartDate.required': 'Please input start date',
    'save': 'Save Changes',
    'save.success': 'Saved successfully',
    'save.error': 'Failed to save',
  },
  'pages.store.memberDetails.record.date': 'Record Date',
  'pages.store.giftCardDetails': {
    'giftCard': 'Gift Card',
    'card.number': 'Gift Card Number',
    'temp.phone': 'Temporary Phone',
    'register.time': 'Registration Time',
    'valid.days': 'Validity (Days)',
    'active.time': 'Activation Time',
    'expiry.time': 'Expiry Time',
    'temp.email': 'Temporary Email',
    'company': 'Company',
    'registration.store': 'Registration Store',
    'store.manager': 'Store Manager',
    'status': 'Status',
    'balance': 'Balance',
    'balance.record': 'Balance Record',
    'record.date': 'Record Date',
    'time': 'Time',
    'points': 'Points',
    'amount': 'Amount',
    'before': 'Before',
    'type': 'Type',
    'type.consume': 'Consume',
    'type.activation': 'Activation',
    'type.refund': 'Refund',
    'type.manual': 'Manual',
    'description': 'Description',
    'send.card': 'Send Gift Card',
    'send.email': 'Send to Email',
    'send.phone': 'Send to Phone',
    'edit.info': 'Edit Information',

    'consumption.record': 'Consumption Record',
    'balance.change.record': 'Balance Change Records',
    'balance.after': 'After',
    'invoice.number': 'Invoice Number',
    'invoice.amount': 'Gift Card Used Amount',
    'invoice.date': 'Invoice Date',
    'please.enter': 'Please Enter',
    'search': 'Search',
    'reset': 'Reset',
    'store': 'Store',
    'action': 'Action',
    'detail': 'Detail',
    'status.active': 'Active',
    'status.inactive': 'Inactive',
    'status.expired': 'Expired',
    'balance.modify': 'Modify Balance',
    'edit.info': 'Edit Information',
    'status.paid': 'Paid',
    'status.refunded': 'Refunded',
    'status.partial_refund': 'Partially Refunded',
    'balanceChangeRecords': 'Balance Change Records',
    'consumptionRecords': 'Consumption Records',
    'changeTime': 'Change Time',
    'changeAmount': 'Change Amount',
    'operation': 'Operation',
    'operator': 'Operator',
    'selectDate': 'Select Date',
    'search': 'Search',
    'reset': 'Reset',
    'operation.type.recharge': 'Recharge',
    'operation.type.consumption': 'Consumption',
    'operation.type.change': 'Change',
    'operation.source.store': 'Store',
    'operation.source.website': 'Website',
    'send.giftcard': 'Send Gift Card',
    'send.to.phone': 'Send to Phone',
    'send.to.email': 'Send to Email',
    'send.success': 'Sent successfully',
    'send.error': 'Failed to send',
    'balance.modify': 'Balance Modify ',
    'reset.balance': 'Reset Balance',
    'reason': 'Reason',
    'balance.amount': 'Amount',
    'balance.amount.required': 'Please enter amount',
    'balance.amount.min': 'Amount must be greater than 0',
    'balance.reason': 'Modification Reason',
    'balance.reason.required': 'Please enter modification reason',
    'balance.modify.success': 'Modified successfully',
    'balance.modify.error': 'Failed to modify',
  },
  'pages.store.giftCardDetails.balance.change.record': 'Balance Change Records',
  'pages.store.giftCardDetails.changeTime': 'Change Time',
  'pages.store.giftCardDetails.changeAmount': 'Change Amount',
  'pages.store.giftCardDetails.operation': 'Operation',
  'pages.store.giftCardDetails.operator': 'Operator',
  'pages.store.giftCardDetails.selectDate': 'Select Date',
  'pages.store.voucherDetails': {
    'title': 'Voucher Details',
    'tempPhone': 'Temporary Phone',
    'tempEmail': 'Temporary Email',
    'company': 'Company',
    'createTime': 'Create Time',
    'expireTime': 'Expire Time',
    'createStore': 'Create Store',
    'startTime': 'Start Time',
    'Store': 'Store',
    'reset': 'Reset',
    'editInformation': 'Edit Information',
    'editStatus': 'Edit Voucher Status',
    'cancel': 'Cancel',
    'ok': 'OK',
    'delete': 'Delete',
    'delete.confirm': 'Are you sure you want to delete this voucher?',
    'delete.warning': 'This action cannot be undone!',
    'delete.success': 'Deleted successfully',
    'delete.failed': 'Failed to delete',
    'enable': 'Enable',
    'disable': 'Disable',
    'status.update.success': 'Status updated successfully',
    'status.update.failed': 'Failed to update status',
    'send.phone.label': 'Phone Number',
    'send.email.label': 'Email Address',
    'send.phone.placeholder': 'Enter phone number (e.g. 0412345678)',
    'send.email.placeholder': 'Enter email address',
    'send.phone.required': 'Please enter phone number',
    'send.email.required': 'Please enter email address',
    'send.phone.invalid': 'Please enter a valid phone number (10 digits starting with 04)',
    'send.email.invalid': 'Please enter a valid email address',
    'send.sms.success': 'SMS sent successfully',
    'send.sms.failed': 'Failed to send SMS',
    'send.email.success': 'Email sent successfully',
    'send.email.failed': 'Failed to send email',
    'storeManager': 'Store Manager',
    'status': 'Status',
    'amount': 'Voucher Amount',
    'consumption.records': 'Consumption Records',
    'consumption.tradeCode': 'Invoice Number',
    'consumption.invoiceDate': 'Invoice Date',
    'consumption.amount': 'Voucher Used Amount',
    'consumption.store': 'Store',
    'consumption.status': 'Status',
    'consumption.tradeCode.placeholder': 'Please input invoice number',
    'search': 'Search',
    'send.voucher': 'Send Voucher',
    'send.to.phone': 'Send to Phone',
    'send.to.email': 'Send to Email',
    'send.success': 'Sent successfully',
    'send.error': 'Failed to send',
    'balance.modify': 'Balance Modify',
    'balance.amount': 'Amount',
    'balance.amount.required': 'Please enter amount',
    'balance.amount.min': 'Amount must be greater than 0',
    'balance.reason': 'Modification Reason',
    'balance.reason.required': 'Please enter modification reason',
    'balance.modify.success': 'Modified successfully',
    'balance.modify.error': 'Failed to modify',
  },
  'pages.actions': {
    'create': 'Create',
    'edit': 'Edit',
    'delete': 'Delete',
    'view': 'View',
    'search': 'Search',
    'reset': 'Reset',
    'submit': 'Submit',
    'cancel': 'Cancel',
    'confirm': 'Confirm',
  },

 
  'pages.actions.operation': 'Operation',
  'pages.actions.save': 'Save',
  // Staff management
  'pages.staff': {
    'title': 'Staff Management',
    'add': 'Add Staff',
    'list.username': 'Username',
    'list.email': 'Email',
    'list.role': 'Role',
    'list.actions': 'Actions',
    'list.edit': 'Edit',
    'list.delete': 'Delete',
    'list.fetchFailed': 'Failed to fetch staff list',
    'delete.confirm': 'Confirm Delete',
    'delete.content': 'Are you sure you want to delete this staff? This action cannot be undone.',
    'delete.success': 'Deleted successfully',
    'delete.failed': 'Failed to delete',
    'add.title': 'Add Staff',
    'edit.title': 'Edit Staff',
    'add.success': 'Added successfully',
    'add.failed': 'Failed to add',
    'edit.success': 'Updated successfully',
    'edit.failed': 'Failed to update',
    'role.admin': 'Admin',
    'role.staff': 'Staff',
    'tabs.basic': 'Basic Information',
    'tabs.permissions': 'Permissions',
    'form.username': 'Username',
    'form.username.required': 'Please enter username',
    'form.email': 'Email',
    'form.email.required': 'Please enter email',
    'form.email.invalid': 'Invalid email format',
    'form.password': 'Password',
    'form.password.required': 'Please enter password',
    'form.role': 'Role',
    'form.role.required': 'Please select a role',
    'permissions.dashboard': 'Dashboard',
    'permissions.members': 'Member Management',
    'permissions.members.view': 'View Members',
    'permissions.members.create': 'Create Members',
    'permissions.members.edit': 'Edit Members',
    'permissions.members.delete': 'Delete Members',
    'permissions.members.export': 'Export Members',
    'permissions.cards': 'Gift Card Management',
    'permissions.cards.view': 'View Gift Cards',
    'permissions.cards.create': 'Create Gift Cards',
    'permissions.cards.edit': 'Edit Gift Cards',
    'permissions.cards.delete': 'Delete Gift Cards',
    'permissions.cards.export': 'Export Gift Cards',
    'permissions.vouchers': 'Voucher Management',
    'permissions.vouchers.view': 'View Vouchers',
    'permissions.vouchers.create': 'Create Vouchers',
    'permissions.vouchers.edit': 'Edit Vouchers',
    'permissions.vouchers.delete': 'Delete Vouchers',
    'permissions.vouchers.export': 'Export Vouchers',
    'permissions.settings': 'Settings',
    'permissions.staff': 'Staff Management',
    'permissions.selectAll': 'Select All',
    'permissions.hint': 'Selecting a main module will automatically select all its sub-permissions',
    'permissions.fetchFailed': 'Failed to fetch permission data',
  },
  'pages.store.physicalCard': {
    'title': 'Physical Membership Card',
    'download': 'Download Physical Card',
    'description': 'Please contact your POS supplier to obtain membership card resources first.',
    'usage': 'Click the download button to get a list of all inactive physical cards\' Online Member IDs in CSV format. The file will contain all unactivated physical cards\' online member numbers.',
    'downloadSuccess': 'Physical membership card file downloaded successfully',
    'downloadError': 'Failed to download physical card',
    'noPermission': 'You do not have download permission',
    'noDataFound': 'No inactive physical cards found',
  },
  'pages.store.customerExport': {
    'title': 'Export Users',
    'download': 'Export Users',
    'description': 'Export users who have a customer history record within the selected time range.',
    'timeRange': 'Time Range',
    'status': 'Status',
    'statusActive': 'Active',
    'statusAll': 'All',
    'memberLevel': 'Member Level',
    'allMemberLevels': 'All member levels',
    'oneMonth': 'Last 1 month',
    'threeMonths': 'Last 3 months',
    'sixMonths': 'Last 6 months',
    'twelveMonths': 'Last 1 year',
    'success': 'User list exported successfully',
    'error': 'Failed to export user list',
    'noPermission': 'You do not have export permission',
  },
  'pages.store.otherSettings': {
    'title': 'Other Settings',
    'customerRegisterEmailRequired': 'Customer Register Email Required',
    'customerRegisterEmailRequired.description': 'When enabled, customers must provide an email address during registration',
    'save.success': 'Settings saved successfully',
    'save.error': 'Failed to save settings',
  },
  'pages.pointsAudit.title': 'Points Audit',
  'pages.pointsAudit.dateRange': 'Date Range',
  'pages.pointsAudit.get': 'Get',
  'pages.pointsAudit.time': 'Time',
  'pages.pointsAudit.member': 'Member',
  'pages.pointsAudit.currentPoints': 'Current Points',
  'pages.pointsAudit.pointsChange': 'Points Changed',
  'pages.pointsAudit.operator': 'Operator',
  'pages.pointsAudit.actions': 'Actions',
  'pages.pointsAudit.details': 'Details',
  'pages.pointsAudit.total': '{total} records',
  'pages.pointsAudit.loadFailed': 'Failed to load points audit records',
  'pages.pointsAudit.dateRequired': 'Please select a date range',
};
